<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div v-if="showAnti" class="phone-frame">
            <img src="/static/images/zmn/antilogo.png" style="width: 100vw;" />

            <div class="main-content">
                <div class="content-wrapper">


                    <div v-if="antiTrue == 1" class="material-card verification-card">
                        <div class="verification-icon">
                            <span class="material-icons">verified</span>
                        </div>
                        <div class="verification-title">{{ antiMessage }}</div>
                        <div class="verification-subtitle">
                            感谢您对啄木鸟刀具的信任！如有疑问请致电：0574-87586862
                        </div>
                        <div class="verification-time">
                            首次查询时间：{{ firstQueryTime }}
                        </div>
                    </div>
                    <div v-if="antiTrue == 2" class="material-card verification-card-danger">
                        <div class="verification-icon-danger">
                            <span class="material-icons">dangerous</span>
                        </div>
                        <div class="verification-title-red">{{ antiMessage }}</div>
                        <div class="verification-subtitle">
                            如有疑问请致电：0574-87586862
                        </div>
                    </div>

                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">产品信息</div>
                            <div class="section-subtitle">基础产品识别信息</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">shopping_bag</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">产品名称</div>
                                    <div class="info-value">{{ productName }}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">qr_code</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">产品型号</div>
                                    <div class="info-value">{{ productNo }}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">security</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">防伪数码</div>
                                    <div class="info-value">{{ antiCode }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="button-group">
                            <button class="btn" @click="goCompany">企业介绍</button>
                            <button class="btn primary" v-if="antiTrue == 1" @click="goTrace">溯源信息</button>
                        </div>
                    </div>
                </div>
            </div>


        </div>


        <div v-if="showTrace" class="phone-frame">
            <img src="/static/images/zmn/tracelogo.png" style="width: 100vw;" />

            <div class="main-content">
                <div class="content-wrapper">
                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">生产信息</div>
                            <div class="section-subtitle">制造与质量管控数据</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">label</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">产品名称</div>
                                    <div class="info-value">{{ productName }}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">tag</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">产品编号</div>
                                    <div class="info-value">{{ productNo }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">物流信息</div>
                            <div class="section-subtitle">仓储与配送追踪</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">inventory_2</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">出库单号</div>
                                    <div class="info-value">{{ orderNo }}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">calendar_today</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">出库日期</div>
                                    <div class="info-value">{{logisticScanTime && logisticScanTime != "" ? logisticScanTime.substring(0,10) : ""}}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">store</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">出库仓库</div>
                                    <div class="info-value">{{sendName}}</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">add_business</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">收货经销商</div>
                                    <div class="info-value">{{receiveName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">质量认证</div>
                            <div class="section-subtitle">产品质量保障信息</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">verified_user</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">产品认证</div>
                                    <div class="info-value">3C认证</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">check_circle</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">质量检测</div>
                                    <div class="info-value">一等品</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showCompany" class="phone-frame">


            <img src="/static/images/zmn/companylogo.png" style="width: 100vw;" />

            <div class="main-content">
                <div class="content-wrapper">
                    <div class="material-card company-card">
                        <div class="card-content">
                            <div class="company-title">关于我们</div>
                            <div class="company-description">
                                宁波市福达刀片有限公司集科研、生产、营销于一体，二十多年来始终以"创新"为企业灵魂，不断追求技术进步与品质提升。目前，旗下"啄木鸟"品牌美工刀片、单面刀片、工业三联刀片以及用途广泛的各种异型刀片和刀架，覆盖五金工具、建筑装饰、文教用品、日用百货等各行业。在业内有相当高的知名度，在国内外市场享有较高的美誉度。
                            </div>
                        </div>
                    </div>

                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">企业实力</div>
                            <div class="section-subtitle">数据展现发展成果</div>
                        </div>
                        <div class="stats-grid">
                            <div class="stat-item">
                                <div class="stat-number">20+</div>
                                <div class="stat-label">发展年限</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">500+</div>
                                <div class="stat-label">产品种类</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">50+</div>
                                <div class="stat-label">销售国家</div>
                            </div>
                        </div>
                    </div>

                    <div class="material-card">
                        <div class="card-header">
                            <div class="section-title">主营产品</div>
                            <div class="section-subtitle">多元化产品解决方案</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">build</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">美工刀片</div>
                                    <div class="info-value">精密制造，锋利耐用</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">construction</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">工业刀片</div>
                                    <div class="info-value">专业应用，高效切割</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <span class="material-icons">handyman</span>
                                </div>
                                <div class="info-content">
                                    <div class="info-label">异型刀片</div>
                                    <div class="info-value">定制化解决方案</div>
                                </div>
                            </div>
                        </div>
                        <div class="button-group">
                            <button class="btn primary" @click="callMe">联系我们</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<style scoped>
@font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/materialicons/v143/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2) format('woff2');
}

.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}

.container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(375px, 1fr));
    gap: 24px;
    max-width: 1400px;
    margin: 0 auto;
}

.phone-frame {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;
    background: #ffffff;
}

.status-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 44px;
    background: rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(20px);
    z-index: 100;
}

.hero-header {
    height: 200px;
    background: linear-gradient(135deg, #1a73e8 0%, #4285f4 100%);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    overflow: hidden;
}

.hero-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 200"><defs><linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:rgba(255,255,255,0.1);stop-opacity:1" /><stop offset="100%" style="stop-color:rgba(255,255,255,0.05);stop-opacity:1" /></linearGradient></defs><rect width="400" height="200" fill="url(%23grad1)"/><circle cx="320" cy="50" r="30" fill="rgba(255,255,255,0.08)"/><circle cx="80" cy="120" r="20" fill="rgba(255,255,255,0.06)"/></svg>') center/cover;
}

.hero-content {
    text-align: center;
    z-index: 10;
    padding: 0 24px;
}

.hero-icon {
    width: 56px;
    height: 56px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    font-size: 24px;
    backdrop-filter: blur(10px);
}

.hero-title {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 8px;
    letter-spacing: 0.15px;
}

.hero-subtitle {
    font-size: 14px;
    opacity: 0.87;
    font-weight: 400;
}

.main-content {
    height: calc(100% - 100px);
    overflow-y: auto;
    background: #fafafa;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.main-content::-webkit-scrollbar {
    display: none;
}

.content-wrapper {
    padding: 16px;
    padding-bottom: 88px;
}

/* Google Material Design Cards */
.material-card {
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 16px;
    box-shadow:
        0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
}

.material-card:hover {
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
}

.card-header {
    padding: 20px 20px 16px;
    border-bottom: 1px solid #e8eaed;
}

.card-content {
    padding: 20px;
}

.verification-card {
    background: linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%);
    border: 1px solid #34a853;
    text-align: center;
    padding: 24px;
}


.verification-card-red {
    background: linear-gradient(135deg, #fcedca 0%, #f9e0c5 100%);
    border: 1px solid rgb(230, 162, 60);
    text-align: center;
    padding: 24px;
}

.verification-card-danger {
    background: linear-gradient(135deg, #f6e3e3 0%, #fcd3d3 100%);
    border: 1px solid rgb(238, 26, 26);
    text-align: center;
    padding: 24px;
}

.verification-icon {
    width: 48px;
    height: 48px;
    background: #34a853;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white;
    font-size: 24px;
}

.verification-icon-red {
    width: 48px;
    height: 48px;
    background: rgb(245, 108, 108);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white;
    font-size: 24px;
}

.verification-icon-danger {
    width: 48px;
    height: 48px;
    background: rgb(238, 26, 26);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white;
    font-size: 24px;
}

.verification-title {
    font-size: 4.5vw;
    font-weight: 500;
    color: #137333;
    margin-bottom: 8px;
}

.verification-title-red {
    font-size: 4.5vw;
    font-weight: 500;
    color: rgb(245, 108, 108);
    margin-bottom: 8px;
}

.verification-subtitle {
    font-size: 3.3vw;
    color: #5f6368;
    line-height: 1.4;
    margin-bottom: 12px;
}

.verification-time {
    font-size: 3vw;
    color: #5f6368;
    font-weight: 400;
}

/* 信息列表项 */
.info-list {
    padding: 0;
}

.info-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f1f3f4;
    transition: background-color 0.15s ease;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item:hover {
    background-color: #f8f9fa;
}

.info-icon {
    width: 40px;
    height: 40px;
    background: #f8f9fa;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    color: #5f6368;
    font-size: 20px;
}

.info-content {
    flex: 1;
}

.info-label {
    font-size: 12px;
    color: #5f6368;
    font-weight: 400;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
}

.info-value {
    font-size: 4.5vw;
    color: #202124;
    font-weight: 400;
    line-height: 1.3;
}

/* 按钮样式 */
.button-group {
    display: flex;
    gap: 12px;
    padding: 0 20px 20px;
}

.btn {
    flex: 1;
    height: 40px;
    border: 1px solid #dadce0;
    border-radius: 20px;
    background: #ffffff;
    color: #1a73e8;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.btn:hover {
    background: #f8f9fa;
    border-color: #1a73e8;
}

.btn.primary {
    background: #1a73e8;
    color: white;
    border-color: #1a73e8;
}

.btn.primary:hover {
    background: #1557b0;
    box-shadow: 0 1px 3px 0 rgba(26, 115, 232, 0.3);
}

/* 浮动操作按钮 */
.fab {
    position: absolute;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    background: #1a73e8;
    border: none;
    border-radius: 50%;
    color: white;
    font-size: 24px;
    cursor: pointer;
    box-shadow:
        0 3px 5px -1px rgba(0, 0, 0, 0.2),
        0 6px 10px 0 rgba(0, 0, 0, 0.14),
        0 1px 18px 0 rgba(0, 0, 0, 0.12);
    transition: all 0.15s ease;
    z-index: 10;
}

.fab:hover {
    background: #1557b0;
    transform: scale(1.05);
    box-shadow:
        0 5px 5px -3px rgba(0, 0, 0, 0.2),
        0 8px 10px 1px rgba(0, 0, 0, 0.14),
        0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

/* 标题样式 */
.section-title {
    font-size: 5.5vw;
    font-weight: 500;
    color: #202124;
    margin-bottom: 4px;
}

.section-subtitle {
    font-size: 4vw;
    color: #5f6368;
    font-weight: 400;
}

/* 企业介绍特殊样式 */
.company-card {
    background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
    border-left: 4px solid #ff9800;
}

.company-description {
    font-size: 15px;
    line-height: 1.6;
    color: #424242;
    padding: 0;
}

.company-title {
    font-size: 18px;
    font-weight: 500;
    color: #e65100;
    margin-bottom: 16px;
    text-align: center;
}

/* 统计数据 */
.stats-grid {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 20px;
}

.stat-item {
    text-align: center;
    padding: 5vw;
    background: #f8f9fa;
    border-radius: 8px;
}

.stat-number {
    font-size: 7vw;
    font-weight: 600;
    color: #1a73e8;
    margin-bottom: 4px;
}

.stat-label {
    font-size: 3vw;
    color: #5f6368;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .container {
        padding: 16px;
        grid-template-columns: 1fr;
    }

    .phone-frame {
        max-width: 100%;
        height: calc(100vh - 32px);
    }
}

/* 涟漪效果 */
.ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    transform: scale(0);
    animation: ripple-animation 0.6s ease-out;
    pointer-events: none;
}

.btn.primary .ripple {
    background: rgba(255, 255, 255, 0.3);
}

@keyframes ripple-animation {
    to {
        transform: scale(4);
        opacity: 0;
    }
}
</style>

<script>
import { getAntiData, getInfoByCode, getTraceByCode } from '../../api/api'

export default {
    data() {
        return {
            antiCode: "",
            eno: "138251972252",
            showAnti: true,
            showCompany: false,
            showTrace: false,
            antiMessage: "",
            antiTrue: 0,
            firstQueryTime: "",
            productNo: "-",
            productName: "-",
            digitCode: "",
            logisticScanTime: "",
            orderNo: "",
            receiveName: "",
            sendName: ""
        }
    },
    mounted: function () {
        const params = this.$route.query
        this.antiCode = params.c.substring(0,16)
        this.queryAnti()
    }
    ,
    methods: {
        goTrace() {
            this.showAnti = false
            this.showCompany = false
            this.showTrace = true
        },
        goCompany() {
            this.showAnti = false
            this.showCompany = true
            this.showTrace = false
        },
        callMe() {
            window.location.href = "tel:0574-87586862"
        },
        queryAnti() {
            this.getResult()

        },
        async getResult() {
            var res = await getAntiData(this.antiCode, this.eno)
            const data = res.data
            if (data == null || data.code == "500") {
                this.antiTrue = 0
                alert("查询异常，请重新输入防伪码进行查询")
            } else {
                if (data.code === "300102" || data.code == "300101") {
                    this.antiTrue = 1
                    this.firstQueryTime = data.data.firstQueryTime
                    if (data.code === '300101') {
                        this.antiMessage = '首次查询，产品为啄木鸟刀具正品'
                    } else {
                        this.antiMessage = '此码已被多次查询，谨防仿冒'
                    }
                    this.queryCodeInfo()
                } else if (data.code == "300106") {
                    this.antiTrue = 2
                    this.antiMessage = '未查询到此码信息，谨防仿冒'
                }

            }

        },
        async queryCodeInfo() {
            var res = await getInfoByCode(this.antiCode)
            var codeInfoResult = res.data;
            if (codeInfoResult.code == "200" && codeInfoResult.data != null) {
                this.digitCode = codeInfoResult.data.digitCode
                this.queryTrace()
            }
        },
        async queryTrace() {
            var res = await getTraceByCode(this.digitCode, this.eno)
            var traceResult = res.data;
            if (traceResult.code == "200" && traceResult.data != null) {
                this.logisticScanTime = traceResult.data.logisticScanTime
                this.sendName = traceResult.data.sendName
                this.receiveName = traceResult.data.receiveName
                this.orderNo = traceResult.data.orderNo
                this.productName = traceResult.data.productName
                this.productNo = traceResult.data.productNo

            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuoMuNiao/Anti.vue